const fieldValidation = (fieldName: any, fieldValue: string) => {
  if (fieldValue.trim() === '') {
    return `${fieldName} is required`;
  }
  if (fieldValue.trim().length < 3) {
    return `${fieldName} needs to be at least three characters`;
  }
  return null;
};

const emailValidation = (email: string) => {
  if (
    /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(
      email,
    )
  ) {
    return null;
  }
  if (email.trim() === '') {
    return 'Email is required';
  }
  return 'Please enter a valid email';
};

const phoneValidation = (phone: string) => {
  if (
    /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(
      phone,
    )
  ) {
    return null;
  }
  if (phone.trim() === '') {
    return 'Phone is required';
  }
  if (phone.length !== 10) return 'Phone number length should be 10';
  return 'Please enter a valid phone number';
};
const pinValidation = (pin: string) => {
  if (
    /^[1-9][0-9]{5}$/.test(
      pin,
    )
  ) {
    return null;
  }
  if (pin.trim() === '') {
    return 'pin is required';
  }
  if (pin.length !== 6) return 'pin number length should be 6';
  return 'Please enter a valid pin number';
};

export default {
  phoneValidation,
  emailValidation,
  fieldValidation,
  pinValidation,
};
